import { apiFetch } from 'services/apiClient';

import type { CreateStateDto, State } from '../types/State';

export const listStatesByActive = (active = true): Promise<State[]> =>
  apiFetch('/states?active=' + active);

export const listStatesByCountry = (countryId: number, active = true): Promise<State[]> =>
  apiFetch('/countries/' + countryId + '/states?active=' + active);

export const getState = (id: number): Promise<State> =>
  apiFetch('/states/' + id);

export const createState = (data: CreateStateDto): Promise<number> =>
  apiFetch('/states', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const updateState = (id: number, data: CreateStateDto): Promise<void> =>
  apiFetch('/states/' + id, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const deleteState = (id: number): Promise<void> =>
  apiFetch('/states/' + id, { method: 'DELETE' });

export const setStateActive = (id: number, isActive: boolean): Promise<void> =>
  apiFetch('/states/' + id + '/active', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ isActive }),
  });
